import mountCreate from './mountCreate'

export default {
  mountCreate,
}
